import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const tableLayout = {
  fillColor: (rowIndex, node) => {
    if (rowIndex === node.table.body.length - 1) return "#cccccc";
    return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
  },
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
  hLineStyle: (i, node) => {
    if (i === 0 || i === node.table.body.length) return null;
    return { dash: { length: 2, space: 1 } };
  },
  vLineStyle: (i, node) => {
    if (i === 0 || i === node.table.widths.length) return null;
    return { dash: { length: 2 } };
  },
};

const borderLayout = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
  hLineStyle: (i, node) => {
    if (i === 0 || i === node.table.body.length) return null;
    return { dash: { length: 2, space: 1 } };
  },
  vLineStyle: (i, node) => {
    if (i === 0 || i === node.table.widths.length) return null;
    return { dash: { length: 2 } };
  },
};

const reporteConsumoCombustiblePdf = (values) => {
  const {
    empresa,
    vehiculoNombre,
    vehiculoInfo,
    insumoNombre,
    fechaInicio,
    fechaFin,
    ventas,
    facturas,
    stats,
  } = values;

  const terceraColumna = {
    border: [false, false, false, false],
    table: {
      headerRows: 1,
      widths: ["100%"],
      body: [
        [{ text: "Vehículo:", style: "subheader", alignment: "center" }],
        [{ text: vehiculoNombre || "", style: "textoChico", alignment: "center" }],
        [{ text: "Período:", style: "subheader", alignment: "center" }],
        [
          {
            text: `${moment(fechaInicio).format("DD/MM/YYYY")} — ${moment(fechaFin).format("DD/MM/YYYY")}`,
            style: "textoChico",
            alignment: "center",
          },
        ],
        [{ text: "Combustible:", style: "subheader", alignment: "center" }],
        [{ text: insumoNombre || "", style: "textoChico", alignment: "center" }],
        [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
        [{ text: moment().locale("es").format("ll"), style: "textoChico", alignment: "center" }],
      ],
    },
    layout: "noBorders",
  };

  // Filas tabla viajes
  const filasViajes = ventas.map((v) => [
    {
      text: v.fechaVenta ? moment(v.fechaVenta).format("DD/MM/YYYY") : "-",
      style: "textoTabla",
    },
    {
      text:
        v.facturaSerie && v.facturaNumero
          ? `${v.facturaSerie}-${v.facturaNumero}`
          : v.remisionSerie && v.remisionNumero
          ? `${v.remisionSerie}-${v.remisionNumero}`
          : "S/N",
      style: "textoTabla",
    },
    { text: v.cliente || "", style: "textoTabla" },
    { text: v.origenDireccion || "", style: "textoTabla" },
    { text: v.destinoDireccion || "", style: "textoTabla" },
    { text: (v.kmRecorridos || 0).toFixed(2), style: "textoTabla", alignment: "right" },
    { text: dineroDisabledMask(v.totalPagar), style: "textoTabla", alignment: "right" },
  ]);
  filasViajes.push([
    { text: "TOTAL:", style: "tituloTabla", alignment: "left", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: stats.totalKm.toFixed(2), style: "textoTotal", alignment: "right", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
  ]);

  // Filas tabla combustible
  const filasCombustible = facturas.map((f) => [
    { text: f.fechaFactura ? moment(f.fechaFactura).format("DD/MM/YYYY") : "-", style: "textoTabla" },
    { text: f.numeroFactura || "", style: "textoTabla" },
    { text: f.codigoFactura || "", style: "textoTabla" },
    { text: f.proveedor || "", style: "textoTabla" },
    { text: (f.combustibleCantidad || 0).toFixed(3), style: "textoTabla", alignment: "right" },
    { text: dineroDisabledMask(f.combustiblePrecioUnitario), style: "textoTabla", alignment: "right" },
    { text: dineroDisabledMask(f.combustibleSubtotal), style: "textoTabla", alignment: "right" },
    { text: dineroDisabledMask(f.totalPagar), style: "textoTabla", alignment: "right" },
  ]);
  filasCombustible.push([
    { text: "TOTAL:", style: "tituloTabla", alignment: "left", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: stats.totalLitros.toFixed(3), style: "textoTotal", alignment: "right", fillColor: "#cccccc" },
    { text: "", style: "textoTabla", fillColor: "#cccccc" },
    { text: dineroDisabledMask(stats.gastoTotal), style: "textoTotal", alignment: "right", fillColor: "#cccccc" },
    { text: dineroDisabledMask(stats.gastoTotal), style: "textoTotal", alignment: "right", fillColor: "#cccccc" },
  ]);

  const BLANK_PNG =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";

  const dd = {
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          body: [[...HeaderEmpresaCard(empresa || {}, false, false, terceraColumna)]],
        },
        layout: "noBorders",
      },

      // Info vehículo
      ...(vehiculoInfo ? (() => {
        const v = vehiculoInfo;
        const campos = [
          v.marca && { label: "Marca", val: v.marca },
          v.modelo && { label: "Modelo", val: v.modelo },
          v.anoModelo && { label: "Año", val: String(v.anoModelo) },
          v.placas && { label: "Placas", val: v.placas },
          v.descripcion && { label: "Descripción", val: v.descripcion },
          v.pesoBrutoV && { label: "Peso Bruto", val: `${v.pesoBrutoV} kg` },
          v.permisoSCT && { label: "Permiso SCT", val: v.permisoSCT },
          v.primaSeguro && { label: "Prima", val: String(v.primaSeguro) },
          v.aseguradoraRespCivil && { label: "Seg. Resp. Civil", val: `${v.aseguradoraRespCivil}${v.polizaRespCivil ? ` — ${v.polizaRespCivil}` : ""}` },
          v.aseguradoraCarga && { label: "Seg. Carga", val: `${v.aseguradoraCarga}${v.polizaCarga ? ` — ${v.polizaCarga}` : ""}` },
          v.aseguradoraMedAmbiente && { label: "Seg. Med. Amb.", val: `${v.aseguradoraMedAmbiente}${v.polizaMedAmbiente ? ` — ${v.polizaMedAmbiente}` : ""}` },
        ].filter(Boolean);
        const POR_FILA = 4;
        const filas = [];
        for (let i = 0; i < campos.length; i += POR_FILA) {
          const grupo = campos.slice(i, i + POR_FILA);
          while (grupo.length < POR_FILA) grupo.push(null);
          filas.push(grupo.map((c) =>
            c
              ? { stack: [{ text: c.label, style: "labelVehiculo" }, { text: c.val, style: "valorVehiculo" }], border: [false, false, true, false], borderColor: ["", "", "#e0e0e0", ""] }
              : { text: "", border: [false, false, false, false] }
          ));
        }
        return [{ style: "tableExample", table: { widths: ["25%", "25%", "25%", "25%"], body: filas }, layout: "noBorders" }];
      })() : []),

      {
        style: "tableExample",
        table: {
          widths: ["20%", "20%", "20%", "20%", "20%"],
          body: [
            [
              { text: "KM / Litro", style: "tituloTabla", alignment: "center", fillColor: "#1890ff", color: "white" },
              { text: "Costo por KM", style: "tituloTabla", alignment: "center", fillColor: "#52c41a", color: "white" },
              { text: "Total Litros", style: "tituloTabla", alignment: "center", fillColor: "#fa8c16", color: "white" },
              { text: "Gasto Combustible", style: "tituloTabla", alignment: "center", fillColor: "#f5222d", color: "white" },
              { text: "Total KM", style: "tituloTabla", alignment: "center", fillColor: "#722ed1", color: "white" },
            ],
            [
              { text: `${stats.kmPorLitro.toFixed(3)} km/L`, style: "kpiValor", alignment: "center" },
              { text: `$${stats.costoPorKm.toFixed(2)} /km`, style: "kpiValor", alignment: "center" },
              { text: `${stats.totalLitros.toFixed(3)} L`, style: "kpiValor", alignment: "center" },
              { text: dineroDisabledMask(stats.gastoTotal), style: "kpiValor", alignment: "center" },
              { text: `${stats.totalKm.toFixed(2)} km`, style: "kpiValor", alignment: "center" },
            ],
          ],
        },
        layout: borderLayout,
      },

      { text: "Viajes Registrados", style: "subheader", margin: [0, 8, 0, 4] },
      {
        style: "tableExample",
        table: {
          widths: ["9%", "9%", "18%", "18%", "18%", "13%", "15%"],
          body: [
            [
              { text: "Fecha", style: "tituloTabla" },
              { text: "Documento", style: "tituloTabla" },
              { text: "Cliente", style: "tituloTabla" },
              { text: "Origen", style: "tituloTabla" },
              { text: "Destino", style: "tituloTabla" },
              { text: "KM Recorridos", style: "tituloTabla" },
              { text: "Total Venta", style: "tituloTabla" },
            ],
            ...filasViajes,
          ],
        },
        layout: tableLayout,
      },

      { text: "Facturas de Combustible", style: "subheader", margin: [0, 8, 0, 4] },
      {
        style: "tableExample",
        table: {
          widths: ["9%", "7%", "10%", "22%", "10%", "11%", "14%", "17%"],
          body: [
            [
              { text: "Fecha", style: "tituloTabla" },
              { text: "# Factura", style: "tituloTabla" },
              { text: "Código", style: "tituloTabla" },
              { text: "Proveedor", style: "tituloTabla" },
              { text: "Litros", style: "tituloTabla" },
              { text: "Precio / L", style: "tituloTabla" },
              { text: "Subtotal Comb.", style: "tituloTabla" },
              { text: "Total Factura", style: "tituloTabla" },
            ],
            ...filasCombustible,
          ],
        },
        layout: tableLayout,
      },
    ],
    images: { logo: empresa?.logo?.base64Completa || BLANK_PNG },
    styles: {
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      subheader: { fontSize: 8, bold: true },
      labelVehiculo: { fontSize: 7, color: "#888888", bold: false },
      valorVehiculo: { fontSize: 8, bold: true, color: "#262626" },
      tableExample: { margin: [0, 5, 0, 5] },
      tituloTabla: { fontSize: 8, bold: true, fillColor: "#cccccc", alignment: "center" },
      textoTabla: { fontSize: 7, italics: false },
      textoTotal: { fontSize: 7, bold: true },
      textoChico: { fontSize: 8 },
      kpiValor: { fontSize: 10, bold: true },
    },
    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [20, 20, 20, 20],
  };

  return dd;
};

export default reporteConsumoCombustiblePdf;
